import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';
import API_BASE_URL from '../apiConfig'; // <--- This import is now used below
import '../App.css'; 

// --- DYNAMIC URLS ---
const VERIFY_API_URL = `${API_BASE_URL}/verify-email`;
const RESEND_API_URL = `${API_BASE_URL}/resend-verification`;
// --------------------

function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const { loginWithToken, user } = useAuth();
  
  const [status, setStatus] = useState('verifying'); 
  const [resendStatus, setResendStatus] = useState(null); 
  const [resendEmail, setResendEmail] = useState('');
  const hasRun = useRef(false); 

  // --- Core Verification Logic (Runs on Load) ---
  useEffect(() => {
    if (!token) {
        setStatus('error');
        return;
    }

    if (hasRun.current) return;

    const verifyToken = async () => {
        hasRun.current = true; // Lock immediately

        try {
            const response = await axios.post(VERIFY_API_URL, null, { params: { token: token } });
            
            setStatus('success');

            if (response.data.access_token) {
                loginWithToken(response.data.access_token);
            }

        } catch (err) {
            console.error("Verification attempt result:", err.message);
            
            // Critical Fix: Ignore subsequent 400 errors if user is already verified
            setStatus((prevStatus) => {
                if (user) return 'success';
                if (prevStatus === 'success') return prevStatus;
                return 'error';
            });
        }
    };

    verifyToken();
  }, [token, loginWithToken, user]);

  // --- Resend Form Submission Handler ---
  const handleResendRequest = async (e) => {
    e.preventDefault();
    if (!resendEmail) return;

    setResendStatus('sending');
    try {
        // Now RESEND_API_URL is defined and ready to be called
        await axios.post(RESEND_API_URL, { email: resendEmail });
        setResendStatus('success');
    } catch (err) {
        setResendStatus('error');
        alert("Could not send new link. Please check email address.");
    } finally {
        // Keep status visible
    }
  };


  return (
    <div className="App">
      <Navbar />
      <header className="App-header" style={{minHeight: '80vh', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        
        <div className="form-container" style={{
            textAlign: 'center', padding: '40px', maxWidth: '500px', width: '90%', height: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box'
        }}>
            
            {status === 'verifying' && (
                <>
                    <div className="spinner" style={{marginBottom: '20px', width: '40px', height: '40px', borderWidth: '4px'}}></div>
                    <h2 style={{color: '#444', marginTop: 0}}>Verifying your email...</h2>
                </>
            )}

            {status === 'success' && (
                <>
                    <div style={{fontSize: '4rem', marginBottom: '10px'}}>✅</div>
                    <h2 style={{color: '#2e7d32', marginBottom: '15px', marginTop: 0}}>Email Verified!</h2>
                    <p style={{color: '#555', fontSize: '1.1rem', marginBottom: '30px'}}>
                        Your account is active and you are logged in.
                    </p>
                    
                    <Link to="/app" className="generate-button" style={{
                        display: 'block', width: '100%', textDecoration: 'none', padding: '15px 0', margin: '0', fontSize: '1.1rem', fontWeight: 'bold', boxSizing: 'border-box'
                    }}>
                        🚀 Create First Assessment
                    </Link>
                </>
            )}

            {status === 'error' && (
                <>
                    <div style={{fontSize: '4rem', marginBottom: '10px'}}>❌</div>
                    <h2 style={{color: '#d32f2f', marginBottom: '15px', marginTop: 0}}>Verification Failed</h2>
                    <p style={{color: '#555', marginBottom: '30px'}}>The link may be invalid or has already been used.</p>
                    
                    {resendStatus === 'success' ? (
                        <p style={{color: '#2e7d32', fontWeight: 'bold'}}>
                            ✅ New link sent! Check your inbox.
                        </p>
                    ) : (
                        <form onSubmit={handleResendRequest} style={{width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                            <p style={{marginBottom: '10px', color: '#999', fontSize: '0.9rem', width: '100%'}}>
                                Please enter your registered email to receive a new link.
                            </p>
                            <input 
                                type="email" 
                                value={resendEmail} 
                                onChange={(e) => setResendEmail(e.target.value)}
                                placeholder="Your registered email"
                                style={{width: '100%', padding: '10px', marginBottom: '10px', boxSizing: 'border-box'}}
                                required
                            />
                            <button type="submit" className="generate-button" disabled={resendStatus === 'sending'} style={{width: '100%', padding: '12px 0'}}>
                                {resendStatus === 'sending' ? 'Sending New Link...' : 'Get New Verification Link'}
                            </button>
                            <Link to="/login" style={{color: '#0052cc', fontWeight: 'bold', textDecoration: 'none', fontSize: '1rem', marginTop: '10px'}}>

                            </Link>
                        </form>
                    )}

                </>
            )}

        </div>
      </header>
    </div>
  );
}

export default VerifyEmailPage;